import React, { createContext, useContext, useState, useEffect } from 'react';
import { ManagedDropdown } from '../../ManagedDropdown/ManagedDropdown';
import { Dropdown } from './Dropdown';
import { Control } from './Control';
import { ITreeData } from '../Tree/types';
import { IFolderDropdownData } from './types';
import { searchFlatStructure } from './utils';

export interface IFolderDropdownProps {
    disabled?: boolean;
    invalid?: boolean;

    nodes: IFolderDropdownData[];
    onChange: (item: IFolderDropdownData) => void;
    value?: IFolderDropdownData | undefined;

    showCreateNewFolder?: boolean;
    allowSearch?: boolean;
    onCreateNewFolderClick?: () => void;
}

interface IFolderTreeViewContext {
    disabled?: boolean;
    invalid?: boolean;
    id?: string;

    nodes: ITreeData[];
    value?: IFolderDropdownData;

    allowSearch?: boolean;
    allowCreateNewFolder?: boolean;
    search: string;

    onSelectItem: (item: IFolderDropdownData) => void;
    onCreateNewFolderClick?: () => void;
    onSearch: (search: string) => void;
    onClose: () => void;
}

const Context = createContext<IFolderTreeViewContext>({} as any);
export const useProps = () => useContext(Context);

const buildData = (items: IFolderDropdownData[]): ITreeData[] => {
    return items.map<ITreeData>((e) => ({
        ...e,
        isFolder: true,
    }));
};

export const FolderDropdown = ({ nodes, value, onChange, allowSearch, disabled, invalid }: IFolderDropdownProps) => {
    const [data, setData] = useState<ITreeData[]>(buildData(nodes));
    const [currentValue, setCurrentValue] = useState(value);
    const [search, setSearch] = useState('');

    useEffect(() => {
        setCurrentValue(value);
    }, [JSON.stringify(value)]);

    useEffect(() => {
        setData(buildData(nodes));
    }, [JSON.stringify(nodes)]);

    return (
        <Context.Provider
            value={{
                nodes: data,
                value: currentValue,
                allowSearch,
                search,
                disabled,
                invalid,

                onClose: () => {
                    setData(buildData(nodes));
                },

                onSelectItem: (item: ITreeData) => {
                    setCurrentValue(item);
                    onChange(item);
                },

                onSearch: (search: string) => {
                    if (search) {
                        setData(buildData(searchFlatStructure(nodes, search)));
                    } else {
                        setData(buildData(nodes));
                    }

                    setSearch(search);
                },
            }}
        >
            <ManagedControl />
        </Context.Provider>
    );
};

const ManagedControl = () => {
    const { value, disabled } = useProps();

    return (
        <ManagedDropdown
            disabled={disabled}
            width="307px"
            placement="bottom-end"
            manager={(onClick) => <Control onClick={onClick} caption={value?.caption} />}
        >
            <Dropdown />
        </ManagedDropdown>
    );
};
